import { css } from '@emotion/core'
import styled from '@emotion/styled'
import { CSSTransition } from 'react-transition-group'
import {
  radiantBlue,
  gray,
} from '@css/constants'

export const TRANSITION_DELAY = 500

export const pageTransitionName = 'slide-transition'
export const backwardClassName = `${pageTransitionName}-fwd`
export const forwardClassName = `${pageTransitionName}-bwd`

export const SliderWrapper = styled('div')(css``)

export const PaginationContainer = styled('ul')(css`
  display: flex;
  align-items: center;
  justify-content: left;
  list-style: none;

  & > li {
    margin-right: 4px;
  }

  & > li:first-of-type {
    margin-right: 13px;
  }

  & > li:last-of-type {
    margin-left: 9px;
    margin-right: 0;
  }
`)

export const Dot = styled('span')<{ isActive: boolean }>(props => css`
  width: 8px;
  height: 8px;
  background: ${props.isActive ? radiantBlue : gray};
  border-radius: 50%;
  transition: transform ${TRANSITION_DELAY}ms, background ${TRANSITION_DELAY}ms;
  transform: ${props.isActive ? 'scale(2)' : 'none'};
`)

export const btnStyles = css`
  width: 26px;
  height: 26px;
  padding: 0;
  margin: 0;
`

export const CSSTransitionPane = styled(CSSTransition)(css`
  &.${pageTransitionName}-enter {
    opacity: 0;
  }
  .${backwardClassName} &.${pageTransitionName}-enter {
    transform: translateX(-50%);
  }
  .${forwardClassName} &.${pageTransitionName}-enter {
    transform: translateX(50%);
  }

  .${backwardClassName} &.${pageTransitionName}-enter-active,
  .${forwardClassName} &.${pageTransitionName}-enter-active {
    opacity: 1;
    transform: translateX(0%);
  }

  &.${pageTransitionName}-exit {
    opacity: 1;
    transform: translateX(0%);
  }

  &.${pageTransitionName}-exit-active {
    opacity: 0;
  }
  .${backwardClassName} &.${pageTransitionName}-exit-active {
    transform: translateX(50%);
  }
  .${forwardClassName} &.${pageTransitionName}-exit-active {
    transform: translateX(-50%);
  }

  &.${pageTransitionName}-enter-active,
  &.${pageTransitionName}-exit-active {
    transition: opacity ${TRANSITION_DELAY}ms, transform ${TRANSITION_DELAY}ms;
  }
`)
